/* globals ga */

import _ from 'underscore';


export default {
  send_event: function () {
    if (typeof ga === 'undefined') {
      return;
    }
    if (ga.trackEvent) {
      // Cordova GA plugin
      ga.trackEvent.apply(this, arguments);
    } else {
      ga.apply(this, _.union([ 'send', 'event' ], arguments));
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/orcas-core/core/static/js/core/google_analytics.js
// module id = 9
// module chunks = 0